import React, { useContext, useEffect, useState } from "react";
import { Context } from "../../../context/context";
import moment from "moment";
import DateRangePicker from "@wojtekmaj/react-daterange-picker/dist/DateRangePicker";

import "./VolumeProduto.scss";
import { Button } from "@mui/material";
import LineChart from "../../../components/LineChart/LineChart";
import { getVolumeByProduct } from "../../../services/graphics-service";
import { formatGraphicVolumePerProduct } from "../../../utils/formatted-graphic-values";
import SelectInput from "../../../components/Select/SelectInput";
import { getDefaultProducts } from "../../../services/product-service";

const VolumeProduto = () => {
  const { sidebar } = useContext(Context);
  const token = localStorage.getItem("token");
  const [products, setProducts] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [graphicValues, setGraphicValues] = useState({});
  const [showGraphic, setShowGraphic] = useState(false);
  const [dateValue, setDateValue] = useState([
    moment(new Date()).subtract(30, "day").toDate(),
    new Date(),
  ]);

  const getProductList = async () => {
    const products = await getDefaultProducts(token);
    setProducts(products);
  };

  useEffect(() => {
    getProductList();
  }, []);

  const getGraphicData = async () => {
    const result = await getVolumeByProduct(
      token,
      selectedProducts,
      dateValue[0],
      dateValue[1]
    );

    setGraphicValues(formatGraphicVolumePerProduct(result.data.competidores));

    setShowGraphic(true);
  };

  return (
    <main className={sidebar ? "container" : "container-full"}>
      <h1>Volume perdido por produto</h1>

      <div className="graphic-csv-container">
        <p>Favor escolher os produtos para gerar o gráfico</p>

        <DateRangePicker onChange={(e) => setDateValue(e)} value={dateValue} />
        <div>
          <SelectInput
            style={{ width: "272px", marginBottom: "10px" }}
            value={selectedProducts}
            name="Produto"
            setValue={setSelectedProducts}
            selectValues={products}
          />
        </div>

        <Button
          className="generate-btn"
          variant="contained"
          onClick={getGraphicData}
        >
          Gerar gráfico
        </Button>
      </div>

      {showGraphic && (
        <div className="graphic-container">
          <LineChart values={graphicValues} />
        </div>
      )}
    </main>
  );
};

export default VolumeProduto;
